<app-topbar></app-topbar>

<header class="main-header sticky-header sticky-header--normal">
    <app-menu></app-menu>
</header><!-- /.main-header -->

<!-- ── Actions rapides mobile (visible uniquement < 992px) ──────────────── -->
<div class="header-mobile-actions" style="top: 70px;">
    <div class="topbar-one__bottom__info">
        <a href="https://center.arp.gov.mr" class="careox-btn" style="font-size: 12px;"><span>{{'licence' | translate }}</span></a>
    </div> 

    <div class="topbar-one__bottom__info">
        <a [routerLink]="['/paiement']" class="careox-btn" style="font-size: 12px;"><span> {{'paiement' |
                translate}}</span>
        </a>
    </div> 
    <div class="topbar-one__bottom__info"  >
        <a href="/annuaire" class="careox-btn" style="font-size: 12px;">
            <span>  {{'agrees' | translate}}</span></a>
    </div><!-- /.topbar-one__info -->


</div>
<!--
 <a href="/annuaire" class="hma-btn">
         
        <span>{{ 'licence' | translate }}</span>
    </a>
    <a [routerLink]="['/paiement']" class="hma-btn  ">
         
        <span>{{ 'paiement' | translate }}</span>
    </a>
    <a href="/annuaire" class="hma-btn">
         
        <span>{{ 'agrees' | translate }}</span>
    </a>
-->